/* eslint-disable */
export default {
  init() {
    const videofiles = document.querySelectorAll('[data-videosrc]');
    if (videofiles.length > 0) {
      videofiles.forEach(file => {
        const sourceLink = file.dataset.videosrc;
        file.setAttribute('src', sourceLink);
        setTimeout(() => {
          var video = file.parentElement;
          video.load();
        }, 2000);
      });
    }
  }
};
